module.exports = __webpack_public_path__ + "media/images/popup_phone_number@2x-a12d0954.png";